import { defineStore } from "pinia";

export const useForceUpdateStore = defineStore({
  id: "force-update",
  state: () => ({
    required: false,
    hard: true,
    minVersion: null,
  }),
  actions: {
    setRequired({ required, hard, minVersion }) {
      this.required = Boolean(required);
      this.hard = hard !== false;
      this.minVersion = minVersion || null;
    },
    dismiss() {
      if (!this.hard) {
        this.required = false;
      }
    },
  },
});
